<ng-container *ngIf='!inputService.hidden && inputService.formInputDefinition && inputService.control' [formGroup]="inputService.formGroup">
	<mat-slide-toggle value='1' 
		[formControlName]='inputService.formControlKey'
		[matTooltip]='inputService.formInputDefinition.titleTooltip | translate'
	>
		<span>{{inputService.formInputDefinition.name}}</span>
	</mat-slide-toggle>
</ng-container>